// extracted by mini-css-extract-plugin
export default {"NotificationPopup":"NotificationPopup_NotificationPopup__sGO88","NotificationPopup__footer":"NotificationPopup_NotificationPopup__footer__2MQDc"};